import { useMemo } from 'react';

const BASE = { position: 'absolute', pointerEvents: 'none' };
const S   = 'rgba(255,255,255,0.18)';
const SF  = 'rgba(255,255,255,0.11)';
const FA  = 'rgba(255,255,255,0.20)';
const FL  = 'rgba(255,255,255,0.28)';
const FB  = 'rgba(255,255,255,0.05)';
const FDB = 'rgba(255,255,255,0.15)';

// ─── Оригинальная молекула (бензол + боковые цепи) ───────────────────────────
const MoleculeOriginal = ({ style }) => (
  <svg viewBox="0 0 220 220" fill="none" aria-hidden="true"
    style={{ ...BASE, ...style }}>
    <polygon points="110,46 136,60 136,88 110,102 84,88 84,60"
      stroke={S} strokeWidth="1.5" />
    <circle cx="110" cy="74" r="16" stroke="rgba(255,255,255,0.09)" strokeWidth="1" />
    {[[110,46],[136,60],[136,88],[110,102],[84,88],[84,60]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="4" fill={FA} />
    ))}
    <line x1="110" y1="46" x2="110" y2="22" stroke={SF} strokeWidth="1.5" />
    <circle cx="110" cy="15" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="110" y="19" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">N</text>
    <line x1="136" y1="60" x2="158" y2="46" stroke={SF} strokeWidth="1.5" />
    <circle cx="164" cy="42" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="164" y="46" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">O</text>
    <line x1="136" y1="88" x2="160" y2="96" stroke={SF} strokeWidth="1.5" />
    <circle cx="167" cy="99" r="5" fill={FA} />
    <line x1="110" y1="102" x2="110" y2="126" stroke={SF} strokeWidth="1.5" />
    <circle cx="110" cy="133" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="110" y="137" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">O</text>
    <line x1="84" y1="88" x2="60" y2="100" stroke={SF} strokeWidth="1.5" />
    <circle cx="53" cy="104" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="53" y="108" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">N</text>
    <line x1="47" y1="104" x2="28" y2="114" stroke={SF} strokeWidth="1" />
    <circle cx="23" cy="117" r="4" fill={FA} />
    <line x1="84" y1="60" x2="60" y2="46" stroke={SF} strokeWidth="1.5" />
    <circle cx="53" cy="42" r="5" fill={FA} />
    <polygon points="164,42 182,30 196,46 182,62 164,55"
      stroke={SF} strokeWidth="1" />
    {[[164,42],[182,30],[196,46],[182,62],[164,55]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="3" fill={FA} />
    ))}
  </svg>
);

// ─── Допамин ─────────────────────────────────────────────────────────────────
const MoleculeDopamine = ({ style }) => (
  <svg viewBox="0 0 422 172.7" fill="none" aria-hidden="true"
    style={{ ...BASE, ...style }}>
    {/* Каркас молекулы */}
    <path stroke={S} strokeWidth="2"
      d="M303.1,56.4l-49.3-28.5l-0.6-0.3l-0.6,0.3l-49.3,28.5L154,27.9l-0.6-0.3l-0.6,0.3
         l-49.3,28.5L69.6,36.8l-1.2,2.1l33.9,19.6v56.2l-31.2,18l1.2,2.1l31.2-18l47.6,27.5
         l1.7,1l0.6,0.3l0.6-0.3l1.7-1l46.4-26.8l1.7-1l0.6-0.3v-2.7V58.5L252.1,31l1.1-0.7
         l1.1,0.7l46.4,26.8l1.7,1l0.6,0.3l0.6-0.3l33.1-19.1l-1.2-2.1L303.1,56.4z
         M202.1,114.7l-1.1,0.7l-46.4,26.8l-1.1,0.7l-48.7-28.1V58.5L152.3,31l1.1-0.7
         l1.1,0.7l47.6,27.5v57.2z" />
    {/* Двойные связи */}
    <rect x="112.7" y="63.7" width="2.4" height="45.6" fill={S} />
    <rect x="172" y="98"
      transform="matrix(-0.4996 -0.8663 0.8663 -0.4996 155.0786 331.1513)"
      width="2.4" height="45.6" fill={S} />
    <rect x="150.4" y="51.1"
      transform="matrix(-0.866 -0.5 0.5 -0.866 296.997 184.2648)"
      width="45.6" height="2.4" fill={S} />
    {/* HO (верхний) */}
    <path fill={FL} d="M53.7,14.2c-8,0-13,5.6-13,14.6c0,8.9,5,14.6,13,14.6
      c8,0,13-5.6,13-14.6C66.6,19.8,61.6,14.2,53.7,14.2z
      M53.7,40c-5.8,0-9.4-4.4-9.4-11.3c0-7,3.6-11.3,9.4-11.3
      c5.8,0,9.4,4.4,9.4,11.3C63,35.7,59.4,40,53.7,40z" />
    <polygon fill={FL}
      points="33.2,26.8 17.7,26.8 17.7,14.6 14.2,14.6 14.2,42.8 17.7,42.8
               17.7,30 33.2,30 33.2,42.8 36.7,42.8 36.7,14.6 33.2,14.6" />
    {/* HO (нижний) */}
    <path fill={FL} d="M53.7,129.4c-8,0-13,5.6-13,14.6s5,14.6,13,14.6
      c8,0,13-5.6,13-14.6S61.6,129.4,53.7,129.4z
      M53.7,155.2c-5.8,0-9.4-4.4-9.4-11.3c0-7,3.6-11.3,9.4-11.3
      c5.8,0,9.4,4.4,9.4,11.3C63,150.9,59.4,155.2,53.7,155.2z" />
    <polygon fill={FL}
      points="33.2,142 17.7,142 17.7,129.8 14.2,129.8 14.2,158 17.7,158
               17.7,145.2 33.2,145.2 33.2,158 36.7,158 36.7,129.8 33.2,129.8" />
    {/* NH2 */}
    <polygon fill={FL}
      points="360.7,36.5 360.6,36.5 345.1,14.4 341.7,14.4 341.7,42.6
               345.2,42.6 345.2,20.5 345.4,20.5 360.8,42.6 364.2,42.6 364.2,14.4 360.7,14.4" />
    <polygon fill={FL}
      points="387.2,26.6 371.7,26.6 371.7,14.4 368.2,14.4 368.2,42.6
               371.7,42.6 371.7,29.8 387.2,29.8 387.2,42.6 390.7,42.6 390.7,14.4 387.2,14.4" />
    <path fill={FL} d="M398.2,46.7l5-5.2c3.3-3.4,4.3-5,4.3-7.2c0-3-2.8-5.4-6.3-5.4
      c-3.7,0-6.5,2.6-6.5,6h2.4c0-2.2,1.8-3.9,4.1-3.9c2.2,0,3.9,1.5,3.9,3.4
      c0,1.6-0.6,2.7-3.3,5.5l-6.9,7.3v1.7h13v-2.2H398.2z" />
  </svg>
);

// ─── Тестостерон ─────────────────────────────────────────────────────────────
const MoleculeTestosterone = ({ style }) => (
  <svg viewBox="0 0 455.07 303.36" fill="none" aria-hidden="true"
    style={{ ...BASE, ...style }}>
    {/* Стероидный скелет */}
    <path stroke={S} strokeWidth="1.5"
      d="M127.56,275.63l49.88-28.8l49.88,28.8l51.08-29.49v-57.6l48.82-28.19
         l55.1,17.9l34.88-48.01l-33.96-46.74l15.52-32.48l-11.41-3.71l-6.53,35.4
         l-52.4,17.03l4.66-55.9h-12l4.62,55.42l-48.5-28l-51.08,29.49v57.6
         l-47.3,27.31l4.62-55.42h-12l4.62,55.42l-48.5-28l-51.08,29.49v51.61
         l-33.92,19.59l1.2,2.08l32.72-18.89v4.6l3.98,2.3l-32.72,18.89
         l1.2,2.08l33.92-19.59L127.56,275.63z
         M381.42,85.06l32.83,45.19l-32.83,45.19l-53.12-17.26v-55.86L381.42,85.06z
         M277.21,74.04l48.68,28.11v56.21L278.7,185.6l4.51-34.64h-12l4.51,34.64
         l-47.19-27.25v-56.21L277.21,74.04z
         M227.33,160.43l48.68,28.11v56.21l-48.68,28.11l-48.68-28.11v-56.21L227.33,160.43z
         M78.88,188.54l48.68-28.11l48.68,28.11v56.21l-48.68,28.11l-48.68-28.11V188.54z" />
    {/* Двойная связь */}
    <rect x="124.5" y="249.67"
      transform="matrix(0.866 -0.5001 0.5001 0.866 -105.7124 107.2956)"
      width="45.63" height="2.4" fill={S} />
    {/* O (кетон, левый нижний) */}
    <path fill={FL} d="M35.03,261.45c-2.12-1.26-4.51-1.89-7.15-1.89
      c-4.04,0-7.33,1.34-9.88,4.03s-3.83,6.41-3.83,11.16
      c0,2.51,0.55,4.9,1.64,7.15s2.7,4.03,4.82,5.33s4.53,1.95,7.23,1.95
      c2.49,0,4.8-0.59,6.95-1.77s3.81-2.91,4.98-5.21s1.76-4.89,1.76-7.79
      c0-2.87-0.56-5.43-1.67-7.69S37.16,262.71,35.03,261.45z
      M34.89,282.93c-1.84,2.01-4.19,3.01-7.04,3.01
      c-2.8,0-5.13-0.99-6.98-2.98s-2.78-4.7-2.78-8.15
      c0-4.31,0.97-7.39,2.9-9.23s4.24-2.76,6.92-2.76
      c1.89,0,3.59,0.48,5.11,1.44c1.52,0.96,2.67,2.3,3.46,4.04
      s1.18,3.77,1.18,6.1C37.65,278.08,36.73,280.93,34.89,282.93z" />
    {/* H (метиновые) */}
    <polygon fill={FL}
      points="269.76,131.2 284.64,131.2 284.64,144.69 288.43,144.69
               288.43,116.06 284.64,116.06 284.64,127.82 269.76,127.82
               269.76,116.06 265.97,116.06 265.97,144.69 269.76,144.69" />
    <polygon fill={FL}
      points="219.88,217.6 234.76,217.6 234.76,231.09 238.55,231.09
               238.55,202.46 234.76,202.46 234.76,214.22 219.88,214.22
               219.88,202.46 216.09,202.46 216.09,231.09 219.88,231.09" />
    {/* Маркеры двойных связей */}
    <polygon fill={FDB} points="232.9,193.56 221.76,193.56 221.33,195.96 233.33,195.96" />
    <polygon fill={FDB} points="230.71,181.32 223.94,181.32 223.51,183.72 231.14,183.72" />
    <polygon fill={FDB} points="228.53,169.08 226.13,169.08 225.7,171.48 228.96,171.48" />
    {/* OH (правый верхний) */}
    <path fill={FL} d="M392.52,41.85c2.12,1.3,4.53,1.95,7.23,1.95
      c2.48,0,4.8-0.59,6.95-1.77s3.81-2.91,4.98-5.21s1.76-4.89,1.76-7.79
      c0-2.87-0.56-5.43-1.67-7.69c-1.12-2.26-2.73-4.02-4.86-5.28
      s-4.5-1.89-7.15-1.89c-4.04,0-7.33,1.34-9.88,4.03
      s-3.83,6.41-3.83,11.16c0,2.51,0.55,4.9,1.64,7.15S390.39,40.55,392.52,41.85z
      M392.86,20.2c1.93-1.84,4.24-2.76,6.92-2.76
      c1.89,0,3.59,0.48,5.11,1.44c1.52,0.96,2.67,2.3,3.45,4.04
      c0.79,1.74,1.18,3.77,1.18,6.1c0,3.69-0.92,6.53-2.76,8.54
      c-1.84,2.01-4.19,3.01-7.04,3.01c-2.8,0-5.13-0.99-6.98-2.98
      c-1.86-1.99-2.79-4.7-2.79-8.15C389.96,25.12,390.92,22.04,392.86,20.2z" />
    <polygon fill={FL}
      points="422.22,29.82 437.11,29.82 437.11,43.31 440.9,43.31
               440.9,14.68 437.11,14.68 437.11,26.44 422.22,26.44
               422.22,14.68 418.43,14.68 418.43,43.31 422.22,43.31" />
    <polygon fill={FL}
      points="338.31,231.09 338.31,202.46 334.52,202.46 334.52,214.22
               319.64,214.22 319.64,202.46 315.85,202.46 315.85,231.09
               319.64,231.09 319.64,217.6 334.52,217.6 334.52,231.09" />
    <polygon fill={FDB} points="321.09,195.96 333.09,195.96 332.66,193.56 321.52,193.56" />
    <polygon fill={FDB} points="323.28,183.72 330.91,183.72 330.48,181.32 323.71,181.32" />
    <polygon fill={FDB} points="325.89,169.08 325.46,171.48 328.72,171.48 328.29,169.08" />
  </svg>
);

// ─── Кофеин (нарисован вручную) ───────────────────────────────────────────────
const MoleculeCaffeine = ({ style }) => (
  <svg viewBox="0 0 240 195" fill="none" aria-hidden="true"
    style={{ ...BASE, ...style }}>
    {/* Шестичленное кольцо (пиримидиновая часть) */}
    <polygon points="55,80 55,130 100,158 145,130 145,80 100,52"
      stroke={S} strokeWidth="1.5" />
    {/* Пятичленное кольцо (имидазольная часть) */}
    <polygon points="145,80 145,130 178,150 200,110 178,60"
      stroke={S} strokeWidth="1.5" />
    {/* C=O левый (двойная связь к кислороду) */}
    <line x1="43" y1="98" x2="18" y2="98" stroke={SF} strokeWidth="1.5" />
    <line x1="43" y1="104" x2="18" y2="104" stroke={SF} strokeWidth="1.5" />
    <circle cx="11" cy="101" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="11" y="105" textAnchor="middle" fontSize="7"
      fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">O</text>
    {/* C=O верхний */}
    <line x1="75" y1="42" x2="75" y2="18" stroke={SF} strokeWidth="1.5" />
    <line x1="81" y1="42" x2="81" y2="18" stroke={SF} strokeWidth="1.5" />
    <circle cx="78" cy="12" r="6" stroke={S} strokeWidth="1" fill={FB} />
    <text x="78" y="16" textAnchor="middle" fontSize="7"
      fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">O</text>
    {/* N1-CH3 (верхний левый) */}
    <line x1="55" y1="80" x2="30" y2="63" stroke={SF} strokeWidth="1.5" />
    <circle cx="23" cy="59" r="8" stroke={S} strokeWidth="1" fill={FB} />
    <text x="23" y="63" textAnchor="middle" fontSize="6"
      fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">CH₃</text>
    {/* N3-CH3 (нижний левый) */}
    <line x1="55" y1="130" x2="30" y2="147" stroke={SF} strokeWidth="1.5" />
    <circle cx="23" cy="152" r="8" stroke={S} strokeWidth="1" fill={FB} />
    <text x="23" y="156" textAnchor="middle" fontSize="6"
      fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">CH₃</text>
    {/* N7-CH3 (правый верхний) */}
    <line x1="178" y1="60" x2="193" y2="38" stroke={SF} strokeWidth="1.5" />
    <circle cx="199" cy="30" r="8" stroke={S} strokeWidth="1" fill={FB} />
    <text x="199" y="34" textAnchor="middle" fontSize="6"
      fill="rgba(255,255,255,0.30)" fontFamily="sans-serif">CH₃</text>
    {/* Атомы шестичленного кольца */}
    {[[55,80],[55,130],[100,158],[145,130],[145,80],[100,52]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="3.5" fill={FA} />
    ))}
    {/* Атомы пятичленного кольца (без дублей) */}
    {[[178,60],[200,110],[178,150]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="3.5" fill={FA} />
    ))}
  </svg>
);

// ─── Рандомный выбор при каждом рендере страницы ─────────────────────────────
const MOLECULES = [MoleculeOriginal, MoleculeDopamine, MoleculeTestosterone, MoleculeCaffeine];

const MoleculeDecor = ({ style }) => {
  const Molecule = useMemo(
    () => MOLECULES[Math.floor(Math.random() * MOLECULES.length)],
    []
  );
  return <Molecule style={style} />;
};

export default MoleculeDecor;
